import * as React from "react";
import { AmbientBackground } from "@/components/landing";
import { ProfileForm } from "@/components/auth";
import { Home, LayoutDashboard } from "lucide-react";
import { AppHeader } from "@/pages/shared/components/AppHeader";

export function ProfileContent() {
  const navLinks = [
    { to: "/", label: "Home", icon: <Home className="mr-2 h-4 w-4" /> },
    {
      to: "/dashboard",
      label: "Dashboard",
      icon: <LayoutDashboard className="mr-2 h-4 w-4" />,
    },
  ];

  return (
    <div className="relative min-h-screen">
      <AmbientBackground />

      <AppHeader navLinks={navLinks} />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Profile Settings</h1>
          <ProfileForm />
        </div>
      </main>
    </div>
  );
}

export default ProfileContent;
